import React from "react";
import styles from "../UploadImageQR.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpFromBracket } from "@fortawesome/pro-regular-svg-icons";
import { COLORS } from "../../../constants.js";

export default function UploadMultipleImageFileInputButton(props) {
    const { multipleImageQrProps, htmlUploadId, uploadButtonText } = props;
    const { onFileInputChange, readOnly } = multipleImageQrProps;

    return (
        <>
            {!readOnly && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "1px",
                        marginBottom: "20px",
                        width: "100%",
                    }}
                >
                    <button
                        type="button"
                        style={{
                            background: "#f4f6f8",
                            color: COLORS.BLACK,
                            width: "100%",
                            height: "62px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            outline: "1px solid " + COLORS.GRAY,
                        }}
                    >
                        <label
                            htmlFor={htmlUploadId}
                            className={styles["upload-button-label"]}
                            style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowUpFromBracket} size={"lg"} />
                            <span
                                style={{
                                    marginLeft: "10px",
                                    fontWeight: 500,
                                }}
                            >
                                {uploadButtonText}
                            </span>
                        </label>
                    </button>
                    <input style={{ display: "none" }} onChange={onFileInputChange} value={""} id={htmlUploadId} multiple type="file" accept="image/*" max={5} />
                </div>
            )}
        </>
    );
}
